var map = {
	"./acao-perfil.service": [
		"./src/app/core/services/acao-perfil.service.ts"
	],
	"./acoes.service": [
		"./src/app/core/services/acoes.service.ts"
	],
	"./agenda-geral.service": [
		"./src/app/core/services/agenda-geral.service.ts"
	],
	"./agenda.service": [
		"./src/app/core/services/agenda.service.ts"
	],
	"./atendimento.service": [
		"./src/app/core/services/atendimento.service.ts"
	],
	"./autenticacao.service": [
		"./src/app/core/services/autenticacao.service.ts"
	],
	"./categorias.service": [
		"./src/app/core/services/categorias.service.ts"
	],
	"./causas-raiz.service": [
		"./src/app/core/services/causas-raiz.service.ts"
	],
	"./config/atendimento/atendimento-config.service": [
		"./src/app/core/services/config/atendimento/atendimento-config.service.ts"
	],
	"./config/componentes-config.service": [
		"./src/app/core/services/config/componentes-config.service.ts"
	],
	"./config/empresa-config.service": [
		"./src/app/core/services/config/empresa-config.service.ts"
	],
	"./config/estrutura/get-services.service": [
		"./src/app/core/services/config/estrutura/get-services.service.ts"
	],
	"./config/loja-config.service": [
		"./src/app/core/services/config/loja-config.service.ts"
	],
	"./config/metas-config.service": [
		"./src/app/core/services/config/metas-config.service.ts"
	],
	"./config/modulos-config.service": [
		"./src/app/core/services/config/modulos-config.service.ts"
	],
	"./config/paginas-config.service": [
		"./src/app/core/services/config/paginas-config.service.ts"
	],
	"./config/routing-config.service": [
		"./src/app/core/services/config/routing-config.service.ts"
	],
	"./config/usuarios-config.service": [
		"./src/app/core/services/config/usuarios-config.service.ts"
	],
	"./desafios.service": [
		"./src/app/core/services/desafios.service.ts"
	],
	"./dimensoes.service": [
		"./src/app/core/services/dimensoes.service.ts"
	],
	"./documentos-json.service": [
		"./src/app/core/services/documentos-json.service.ts"
	],
	"./indicadores.service": [
		"./src/app/core/services/indicadores.service.ts"
	],
	"./lojas.service": [
		"./src/app/core/services/lojas.service.ts"
	],
	"./matriz-cha.service": [
		"./src/app/core/services/matriz-cha.service.ts"
	],
	"./maturidade.service": [
		"./src/app/core/services/maturidade.service.ts"
	],
	"./power-bi.service": [
		"./src/app/core/services/power-bi.service.ts"
	],
	"./requisicao-interceptor.service": [
		"./src/app/core/services/requisicao-interceptor.service.ts"
	],
	"./skus.service": [
		"./src/app/core/services/skus.service.ts"
	],
	"./socket.service": [
		"./src/app/core/services/socket.service.ts"
	],
	"./subdimensoes.service": [
		"./src/app/core/services/subdimensoes.service.ts"
	],
	"./swot.service": [
		"./src/app/core/services/swot.service.ts",
		"common"
	],
	"./usuarios-papeis.service": [
		"./src/app/core/services/usuarios-papeis.service.ts",
		0
	],
	"./usuarios.service": [
		"./src/app/core/services/usuarios.service.ts"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/app/core/services lazy recursive ^\\.\\/.*\\.service$";
module.exports = webpackAsyncContext;